var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgChevronRight = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 17 16"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#000",
  d: "m6.404.382 5.822 6.857c.35.471.38.969 0 1.523l-5.822 6.857c-.375.468-1.105.509-1.54.101-.435-.407-.49-1.183-.086-1.625L10.155 8 4.778 1.905c-.403-.442-.36-1.218.075-1.626s1.176-.365 1.55.103"
})));
export default SvgChevronRight;